import { render, staticRenderFns } from "./SchemaAttributesReader.vue?vue&type=template&id=485e1803&scoped=true&"
import script from "./SchemaAttributesReader.vue?vue&type=script&lang=js&"
export * from "./SchemaAttributesReader.vue?vue&type=script&lang=js&"
import style0 from "./SchemaAttributesReader.vue?vue&type=style&index=0&id=485e1803&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e1803",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VDivider,VIcon,VRow})
